// extracted by mini-css-extract-plugin
export default {"records":"RecentlyAddedRecordsList_records__o3BLi","recordstr":"RecentlyAddedRecordsList_recordstr__kJOdN"};